import { ReactPortal, useEffect } from "react";
import { createPortal } from "react-dom";

// @ts-expect-error TS(7031) FIXME: Binding element 'children' implicitly has an 'any'... Remove this comment to see the full error message
const Portal = ({ children }) => {
  const mount = document.getElementById("portal-root");
  const el = document.createElement("div");

  // @ts-expect-error TS(2345) FIXME: Argument of type '() => () => HTMLDivElement' is n... Remove this comment to see the full error message
  useEffect(() => {
    // @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
    mount.appendChild(el);
    // @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
    return () => mount.removeChild(el);
  }, [el, mount]);

  return createPortal(children, el) as ReactPortal;
};

export default Portal;
